import { ApiPaths } from "../../../api/ApiPaths";
import { ApiRequest } from "../../../api/ApiRequest";

export type GetCareCommentAnalysisDataListSuccessResponseType = {
    analysisDataList: {
        createdTime: string,
        houseId: string,
        title: string,
        registerCount: number,
        userDataList: {
            userName: string,
            email: string,
            role: string,
            readTime: string | null
        }[]
    }[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getCareCommentAnalysisDataList(): Promise<GetCareCommentAnalysisDataListSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.admin.careCommentAnalysis,
        {},
        () => {},
        () => {}
    );
}